/* Puente entre la portada (prototipo) y Shopify: carrito real, productos, cuenta. */
(function () {
  var cfg = window.BN_CFG || {};
  var raiz = (cfg.raiz || '/').replace(/\/?$/, '/');
  var subs = [];
  var carrito = null;
  function avisar(c) { carrito = c; subs.forEach(function (f) { try { f(c); } catch (e) {} }); try { document.querySelectorAll('[data-bn-contador]').forEach(function (b) { b.textContent = c.item_count; b.hidden = !c.item_count; }); } catch (e) {} return c; }
  function pedir(url, datos) {
    var op = datos ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(datos), credentials: 'same-origin' } : { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    return fetch(raiz + url, op).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function cargar() { return pedir('cart.js').then(avisar); }
  var BNS = {
    productos: window.BN_P || {},
    cliente: cfg.cliente || null,
    urls: cfg.urls || {},
    get carrito() { return carrito; },
    alCarrito: function (f) { subs.push(f); if (carrito) f(carrito); },
    cargarCarrito: cargar,
    agregar: function (id, n) { return pedir('cart/add.js', { items: [{ id: Number(id), quantity: n || 1 }] }).then(cargar); },
    cambiar: function (key, n) { return pedir('cart/change.js', { id: key, quantity: n }).then(avisar); },
    pagar: function () { window.location.href = (cfg.urls && cfg.urls.checkout) || '/checkout'; },
    abrirCuenta: function () {
      var sa = document.querySelector('shopify-account');
      var irLogin = function () { if (cfg.urls && cfg.urls.login) window.location.href = cfg.urls.login; };
      if (!sa) return irLogin();
      var btn = null;
      try { btn = sa.shadowRoot && sa.shadowRoot.querySelector('button, [role=button], a'); } catch (x) {}
      if (btn) { btn.click(); return; }
      var slot = sa.querySelector('[slot]');
      if (slot) { slot.click(); return; }
      irLogin();
    },
    cuentaAbierta: function () {
      var sa = document.querySelector('shopify-account');
      try { return !!(sa && sa.shadowRoot && sa.shadowRoot.querySelector('dialog[open], [open]')); } catch (x) { return false; }
    }
  };
  window.BNS = BNS;
  cargar().catch(function () {});
  window.addEventListener('pageshow', function (e) { if (e.persisted) cargar().catch(function () {}); });
})();

/* Los botones de la calculadora llevan a la calculadora dentro de la tienda (ahí se pide iniciar sesión para usarla). */
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('a[href*="calculadoranune.netlify.app"]') : null;
  if (!a) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var hash = '';
  try { hash = new URL(a.href).hash; } catch (x) {}
  window.location.href = '/pages/calculadora' + (hash || '#calculadora');
}, true);

/* WhatsApp: a todos los mensajes que salen de la web se les agrega "vengo desde la web" (el resto del mensaje queda igual). */
(function () {
  if (window.__bnWaWeb) return; window.__bnWaWeb = true;
  var FRASE = 'vengo desde la web';
  function conWeb(url) {
    try {
      var u = new URL(url, location.href);
      if (!/(^|\.)wa\.me$|whatsapp\.com$/.test(u.hostname)) return url;
      var t = u.searchParams.get('text') || '';
      if (/desde la web/i.test(t)) return url;
      if (!t.trim()) t = 'Hola, ' + FRASE + '.';
      else if (/desde la tienda online/i.test(t)) t = t.replace(/desde la tienda online/i, 'desde la web');
      else {
        var m = t.match(/^\s*hola\s*,\s*/i), m2 = t.match(/^\s*\u00a1?\s*hola[^!.?\n]{0,40}[!.]\s*/i);
        if (m) t = 'Hola, ' + FRASE + ', ' + t.slice(m[0].length);
        else if (m2) t = m2[0].replace(/\s*$/, '') + ' Vengo desde la web. ' + t.slice(m2[0].length);
        else t = t.replace(/\s*$/, '') + '\n\nVengo desde la web.';
      }
      u.searchParams.delete('text');
      var resto2 = u.searchParams.toString();
      u.search = '?text=' + encodeURIComponent(t) + (resto2 ? '&' + resto2 : '');
      return u.toString();
    } catch (e) { return url; }
  }
  window.bnConWeb = conWeb;
  function arreglar(a) { var h = a.getAttribute('href'); if (h && /wa\.me\/|whatsapp\.com\//.test(h)) { var n = conWeb(h); if (n !== h) a.setAttribute('href', n); } }
  function todos() { try { document.querySelectorAll('a[href*="wa.me/"], a[href*="whatsapp.com/"]').forEach(arreglar); } catch (e) {} }
  document.addEventListener('click', function (e) { var a = e.target && e.target.closest ? e.target.closest('a[href]') : null; if (a) arreglar(a); }, true);
  var abrir = window.open;
  window.open = function (url) { var args = Array.prototype.slice.call(arguments); if (typeof url === 'string') args[0] = conWeb(url); return abrir.apply(window, args); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  try { new MutationObserver(function () { todos(); }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] }); } catch (e) {}
})();
